import gsap from "gsap";
import scrollTrigger from "gsap/ScrollTrigger";
import {TextPlugin} from "gsap/TextPlugin";
import {initAlpine} from "./init";
import Swiper from 'swiper';
import {Autoplay, Pagination} from 'swiper/modules';

gsap.registerPlugin(scrollTrigger, TextPlugin);

// Info bar closing animation
window.closeInfoBar = (e) => {
    const element = e.closest(".navbar_info-bar-wrapper");
    const closingBar = gsap.timeline()
    closingBar.to(element, {
        autoAlpha: 0,
        duration: 0.3,
        ease: "easeOut",
    })
    closingBar.to(element, {
        height: 0,
        duration: 0.2,
        ease: "easeOut",
    }, '-=0.2')
}

// Header after scroll animation
window.headerAfterScroll = (e) => {
    const infoBar = e.querySelector(".navbar_info-bar-wrapper");
    const navLinks = e.querySelectorAll(".navbar_link");
    const navIcon = e.querySelectorAll(".navbar_menu-button");
    const navBranding = e.querySelectorAll(".navbar_brand");
    const navbarChange = gsap.timeline({ paused: true });
    navbarChange.to(e, { y: '-100%', opacity: 0, duration: 0 });
    if (infoBar) {
        navbarChange.to(infoBar, { height: 0, duration: 0.2, ease: "easeOut", });
        navbarChange.to(infoBar, { autoAlpha: 0, duration: 0.3, ease: "easeOut", });
    }
    navbarChange.to(e, { position: 'fixed',backgroundColor: "rgba(255, 255, 255, 1)" , duration: 0, onComplete: function() {
            e.classList.add('is-scrolled');
        },   onReverseComplete: function() {
            e.classList.remove('is-scrolled');
        } }, '>');
    navbarChange.to([navBranding, navIcon], { color: '#11181c', duration: 0 }, '<');
    navbarChange.to(navLinks, { backgroundColor: '#11181c', duration: 0 }, '<');
    navbarChange.to(e, {
        y: 0,
        opacity: 1,
        duration: 0.3,
        ease: 'ease',
    });
    const firstSection = document.querySelector('.section');
    scrollTrigger.create({
        //trigger: firstSection,
        //start: 'top+=300 top',
        start: '600',
        end: '600',
        onEnter: () => navbarChange.play(),
        onEnterBack: () => navbarChange.timeScale(5).reverse(),
    });
}

// Info bar link icon animation
window.infoBarLinkIcon = (e) => {
    const linkIcon = e.querySelector('.info-bar_link-icon');
    const linkIconMove = gsap.timeline({paused: true})
    linkIconMove.to(linkIcon, {
        x: '0.25rem',
        duration: 0.2,
        ease: "ease",
    })
    e.addEventListener('mouseenter', () => {
        linkIconMove.play()
    });
    e.addEventListener('mouseleave', () => {
        linkIconMove.reverse()
    });
}

// Platfrom section background aniomation
window.platfromSectionBgChange = (e) => {
    const sectionHeadline = e.querySelector('.is-h3');
    const sectionBgAnimation = gsap.timeline({paused: true});
    sectionBgAnimation.from(e, {
        backgroundColor: "rgba(17, 24, 28, 0)",
        duration: 0.2,
        ease: "power1.inOut",
    })
    sectionBgAnimation.from([e, sectionHeadline], {
        color: "#11181c",
        duration: 0.2,
        ease: "power1.inOut",
    }, '<')
    scrollTrigger.create({
        trigger: e,
        start: 'top bottom-=120',
        onEnter: () => sectionBgAnimation.play(),
    });
}

// Clinets slider
window.clientsSlider = (e) => {
    const clientSlider  = e.querySelector('.swiper');
    const clientsSlider = new Swiper(clientSlider, {
        modules: [Pagination, Autoplay],
        autoplay: {delay: 6000, disableOnInteraction: false, },
        pagination: {
            el: e.querySelector(".swiper-bullet-wrapper"),
            clickable: true,
            bulletActiveClass: 'is-active',
            renderBullet: function (index, className) {
                return '<a class="' + className + '"><div class="customers-swiper-bullet_progres-wrapper"><div class="customers-swiper-bullet_progres"></div></div><img src="" loading="lazy" alt="" class="customers-swiper-bullet_logo"></a>';},
        },
    });
    const bulletLogos = e.querySelectorAll('.customers-swiper-bullet_logo');
    const sliderLogos = e.querySelectorAll('.customers-slider_logo');
    bulletLogos.forEach((bulletLogo, index) => {
        const sliderLogo = sliderLogos[index];
        if (sliderLogo) {
            bulletLogo.src = sliderLogo.src;
            bulletLogo.alt = sliderLogo.alt;
        }
    });
}

// Solutions tabs indicator
window.solutionsTabsIndicator = (e) => {
    const tabsMenu = e.querySelector('.solutions_tabs-menu')
    const indicator = document.createElement('div');
    indicator.classList.add('solutions_tabs-menu_indicator')
    tabsMenu.appendChild(indicator)
    const tabsLinks = e.querySelectorAll('.solutions_tabs-menu_link')
    const observer = new MutationObserver((mutationsList, observer) => {
        for(let mutation of mutationsList) {
            if(mutation.target.classList.contains('w--current')) {
                if(mutation.target === tabsLinks[0]) {
                    indicator.style.left = '0%';
                } else if(mutation.target === tabsLinks[1]) {
                    indicator.style.left = `${100 / 3}%`;
                } else if(mutation.target === tabsLinks[2]) {
                    indicator.style.left = `${(100 / 3) * 2}%`;
                }
            }
        }
    });
    const config = { attributes: true, attributeFilter: ['class'], subtree: true };
    tabsLinks.forEach(tabLink => observer.observe(tabLink, config));
}

// Pricing table switch
window.pricingSwitch = (e) => {
    const starterMonthly = e.querySelector('#starter-price').innerText;
    const businessMonthly = e.querySelector('#business-price').innerText;
    const starterAnnual = e.querySelector('#starter-price').getAttribute('wide-annually-price');
    const businessAnnual = e.querySelector('#business-price').getAttribute('wide-annually-price');
    const monthlyButton = e.querySelector('.pricing-table_price-switch_option.is-monthly')
    const annuallyButton = e.querySelector('.pricing-table_price-switch_option.is-annually')
    const switchIndicator = e.querySelector('.pricing-table_price-switch_indicator')
    // Actions
    monthlyButton.addEventListener('click', () => {
        e.querySelector('#starter-price').innerText = starterMonthly;
        e.querySelector('#business-price').innerText = businessMonthly;
        switchIndicator.classList.remove('is-annually');
        monthlyButton.classList.add('is-active');
        annuallyButton.classList.remove('is-active');
    })
    annuallyButton.addEventListener('click', () => {
        e.querySelector('#starter-price').innerText = starterAnnual;
        e.querySelector('#business-price').innerText = businessAnnual;
        switchIndicator.classList.add('is-annually');
        annuallyButton.classList.add('is-active');
        monthlyButton.classList.remove('is-active');
    })


}

// Pricing table sticky header
window.stickyHeaderCalc = (e) => {
    const targetElement = document.querySelector('.navbar');
    const mutationCallback = (mutationsList, observer) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                const newHeight = targetElement.offsetHeight;
                e.style.top = `${newHeight}px`;
            }
        }
    };
    const observer = new MutationObserver(mutationCallback);
    const config = { attributes: true };
    observer.observe(targetElement, config);
}

// Mobile menu top padding
window.mobileMenuTopPadding = (e) => {
    function adjustTopMargin(e) {
        const navbar = document.querySelector('.navbar');
        if (!navbar) {
            console.error('.navbar element not found');
            return;
        }
        const updateMargin = () => {
            const navbarHeight = navbar.offsetHeight;
            e.style.paddingTop = `${navbarHeight}px`;
        };
        updateMargin();
        const resizeObserver = new ResizeObserver(updateMargin);
        resizeObserver.observe(navbar);
        return () => resizeObserver.disconnect();
    }
        if(window.innerWidth < 992) {
            adjustTopMargin(e);
        }
}

// White navbar on load
window.whiteNavbarOnLoad = (e) => {
    const navbarBrand = e.querySelector('.navbar_brand');
    gsap.to(navbarBrand, {color: '#11181c', duration: 0})
}

// Mobile menu open/close
window.mobileMenuOpenClose = (e) => {
        const menuButton = e.querySelector('.navbar_menu-button');
        const navbarBrand = e.querySelector('.navbar_brand');
        const initialNavbarBrandColor = navbarBrand.style.color;
        const navbar = document.querySelector('.navbar')
        const changeToBlack = gsap.timeline({ paused: true });
        changeToBlack.to([menuButton, navbarBrand], {color: "#11181c", duration: 0.3, ease: "power1.inOut"}
            )
        const changeToWhite = gsap.timeline({ paused: true });
        changeToWhite.to([menuButton, navbarBrand], {color: "#ffffff", duration: 0.3, ease: "power1.inOut"}
        )
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.attributeName === 'class') {
                    const classList = menuButton.classList;
                    const navbarState = navbar.classList;  // Move this line inside the forEach loop
                    if (classList.contains('w--open')) {
                        document.body.style.overflow = 'hidden';
                        if (navbarState.contains('is-scrolled')) {

                        } else {
                            changeToBlack.restart();
                        }
                    } else {
                        document.body.style.overflow = 'auto';
                        if (navbarState.contains('is-scrolled')) {

                        } else {
                            if (initialNavbarBrandColor === 'rgb(17, 24, 28)') {
                                changeToBlack.restart();
                            } else {
                                changeToWhite.restart();
                            }

                        }
                    }
                }
            });
        });
        const config = { attributes: true, attributeFilter: ['class'] };
        observer.observe(menuButton, config);
    };

// Data source for the hidden form field
window.dataSourceInput = (e) => {
        let uiSource;
        try {
        let queryStringParams = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });
        uiSource = [document.referrer, queryStringParams.uisource].join(' ').trim();
    } catch {
        // Handle any errors
    }
e.value = uiSource;
}

// Validate book demo checkboxs
window.validateCheckboxDemoFrom = (e) => {
    const submitButton = e.querySelector('.submit_ghost');
    const submitBase = e.querySelector('.button.is-submit');
    submitButton.disabled = true;
    submitBase.style.opacity = '0.24';

    function isCheckboxChecked() {
        const checkboxes = e.querySelectorAll('#use-case-group input[type="checkbox"]');
        for (let checkbox of checkboxes) {
            if (checkbox.checked) {
                return true;
            }
        }
        return false;
    }

    function areRequiredFieldsFilled() {
        const requiredInputs = e.querySelectorAll('input[required], textarea[required], select[required]');
        for (let input of requiredInputs) {
            // For checkbox and radio types, check 'checked' property
            if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) {
                return false;
            }
            // For other input types, check 'value' property
            else if (input.value.trim() === '') {
                return false;
            }
        }
        return true;
    }

    e.addEventListener('change', function(event) {
        const isChecked = isCheckboxChecked();
        const isFilled = areRequiredFieldsFilled();

        const isFormValid = isChecked && isFilled;

        submitButton.disabled = !isFormValid;
        submitBase.style.opacity = isFormValid ? '1' : '0.24';
    });

}







// !!!!!!!!! Keep this Alpine init at the end !!!!!!!!!
window.Webflow ||= [];
window.Webflow.push(() => {
    initAlpine();
});